import React, { useState, useEffect } from 'react';

// Components
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import About from './components/About';
import Resume from './components/Resume';
import Portfolio from './components/Portfolio';
import Blog from './components/Blog';
import Contact from './components/Contact';
import GravityTags from './components/GravityTags';
import Youtube from './components/Youtube.tsx';
// Import global styles
//import './style.css';
import './style/base.css';
import './style/navbar.css';
import './style/pages.css';
import './style/responsive.css';
import './style/sidebar.css';
import './style/youtube.css';

function App() {
  const [activeSection, setActiveSection] = useState('about');
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch('./content.json')
      .then(response => response.json())
      .then(data => {
        setContent(data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error loading content:', error);
        setIsLoading(false);
      });
  }, []);


  
  const renderActiveComponent = () => {
    if (!content) return null;
    
    switch(activeSection) {
      case 'about':
        return <About content={content.about} />;
      case 'resume':
        return <Resume content={content.resume} />;
      case 'portfolio':
        return <Portfolio content={content.portfolio} />;
      case 'Workflows':
        return <Blog content={content.blog} />;
      case 'contact':
        return <Contact content={content.contact} />;
      default:
        return <About content={content.about} />;
    }
  };

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>
      <GravityTags />
      <main>
        <Sidebar content={content?.sidebar} />
        <div className="main-content">
          <Navbar setActiveSection={setActiveSection} />
          {renderActiveComponent()}
        </div>
        <Youtube />
      </main>
    </>
  );
}

export default App;